'use client';
const CLASSNAME_ZERO_RIGHT = 'ds-right-scroll-bar-position';
const CLASSNAME_FULL_WIDTH = 'ds-width-before-scroll-bar';
const CLASSNAME_NO_SCROLLBAR = 'ds-with-scroll-bars-hidden';
const VAR_REMOVED_BAR_SIZE = '--ds-removed-body-scroll-bar-size';
const DATA_SCROLL_LOCKED = 'data-ds-scroll-locked';

export { CLASSNAME_FULL_WIDTH, CLASSNAME_NO_SCROLLBAR, CLASSNAME_ZERO_RIGHT, DATA_SCROLL_LOCKED, VAR_REMOVED_BAR_SIZE };
//# sourceMappingURL=RemoveScrollBarGlobal.contract.js.map
